import gql from 'graphql-tag';

const query = gql`
    mutation unsubscribe($email: String!){
        unsubscribe(email: $email)
    }
`;

export default query;
